// process.env-related utility helpers

export const isProdEnv = (): boolean => process.env.REACT_APP_ENV === 'prod';
export const isTestNodeEnv = (): boolean => process.env.NODE_ENV === 'test';
